const QUESTION_TYPES = [
  'text_area'
];

export default QUESTION_TYPES;
